import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  BehaviorSubject,
  Observable,
  of,
  tap,
} from 'rxjs';
import { EmailPasswordLoginRequest } from '../../requests/email-password-login-request';
import { User } from '../../models/user';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { QrCodeResponse } from '../../responses/qr-code-response';
import { LoginResponse } from '../../responses/login-response';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  currentUser: BehaviorSubject<User> = new BehaviorSubject(
    localStorage.getItem('currentUser')
      ? JSON.parse(localStorage.getItem('currentUser') || '')
      : new User()
  );

  constructor(private router: Router, private http: HttpClient) {}

  public loginWithEmailPassword(
    request: EmailPasswordLoginRequest
  ): Observable<QrCodeResponse> {
    return this.http
      .post<QrCodeResponse>(`${environment.API_URL}/login`, request)
      .pipe(
        tap((response) => {
          localStorage.setItem('token', response.token);
          return response;
        })
      );
  }

  public loginWithVerificationCode(
    verificationCode: string
  ): Observable<LoginResponse> {
    return this.http
      .post<LoginResponse>(`${environment.API_URL}/login-2fa`, {
        code: verificationCode,
      }, { withCredentials: true})
      .pipe(
        tap((response) => {
          localStorage.setItem('token', response.token);
          this.updateCurrentUser(response);
          return response;
        })
      );
  }

  public isVerificationCodeAuthenticated(): Observable<boolean> {
    return of(localStorage.getItem('token') !== null).pipe(
      tap((response) => {
        if (!response) {
          this.router.navigateByUrl('login');
        }
      })
    );
  }

  public logout(): void {
    this.router.navigateByUrl('login');

    this.http
      .post<void>(`${environment.API_URL}/logout`, null)
      .subscribe(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('currentUser');
      });
  }

  public updateCurrentUser(user: User | LoginResponse) {
    if (user instanceof User) {
      this.currentUser.next(user);
    } else {
      this.currentUser.next({
        email: user.email,
        uid: user.uid,
        username: user.username,
        active: true,
      });
    }

    localStorage.setItem('currentUser', JSON.stringify(user));
  }

  public refreshToken() : Observable<any> {
    return this.http.get(`${environment.API_URL}/refresh`, {withCredentials: true}).pipe(
        tap((response: any) => {
          localStorage.setItem('token', response.token);
          this.updateCurrentUser(response);
          return response;
        })
      );
  }
}
